import { render, staticRenderFns } from "./ImportTemplateEditForm.vue?vue&type=template&id=1c530410&scoped=true&"
import script from "./ImportTemplateEditForm.vue?vue&type=script&lang=js&"
export * from "./ImportTemplateEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ImportTemplateEditForm.vue?vue&type=style&index=0&id=1c530410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c530410",
  null
  
)

export default component.exports